<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import store from "@/store";
import {siteConfig} from "@/utils/config";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";

const prop = defineProps(['show', 'product'])
const emit = defineEmits(['closed', 'success'])
const showProduct = ref(false)
const changeProduct = ref({})
const account = computed(() => store.state.account)
const loading = ref(false)
const rechargeMobile = ref("")
const sendSms = ref(false)
const realDialog = ref(false)
// const couponName = computed(() => store.state.coupon)
const copType = computed(() => {
  return siteConfig.fandeng
})
const logo = require("@/assets/images/fandeng/MinCard.png")
const order_from = computed(() => {
  return store.state.orderFrom
})
onMounted(() => {
  store.commit("getCoupon")
  store.dispatch("getAccounts")
  store.commit("getOrderFrom")
  showProduct.value = prop.show
  changeProduct.value = prop.product
})
const pay = () => {
  //判断是否输入手机号
  if (!/^1[2-9]\d{9}$/.test(rechargeMobile.value)) {
    return ElMessage.error({message: `请输入${couponName.value}会员手机号`})
  }
  if (!sendSms.value) {
    sendSms.value = true;
    return;
  }
  loading.value = true
  sendSms.value = false;
  new axiosApi({
    encode: "coupon",
    method: "life/pay",
    body: {
      cust_id: account.value.cust_id,
      product: changeProduct.value.third_id,
      plate: changeProduct.value.from_items,
      account: rechargeMobile.value,
      type: copType.value.login,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7401") {
      return ElMessage.error({message: res.message.content})
    } else if (res.message.code === '7401') {
      realDialog.value = true;
      return
    }
    showProduct.value = false
    emit("success")
    store.commit("setOrder", res.data)
  }, () => loading.value = false)
}
</script>

<template>
  <el-drawer direction="btt" v-model="showProduct" :with-header="false" class="product-drawer" size="500"
             @closed="emit('closed')">
    <div class="product-detail">
      <div class="product-title">
        <div class="product-logo">
          <el-image :src="logo"/>
          <div class="product-type">
            <span class="product-type-name">{{ product.remarks.type }}</span>
            <span class="product-type-jingle">VIP</span>
          </div>
        </div>
        <div class="product-values">
          <h3>{{ product.remarks.brand }}{{ product.remarks.type }}VIP</h3>
          <div class="product-money">
            <el-text type="danger">{{ product?.mileTypes[copType.login]?.total }}</el-text>
            <span>{{ product?.mileTypes[copType.login]?.unit }}</span>
          </div>
          <el-text type="warning">输入的手机号将自动注册为帆书会员</el-text>
        </div>
      </div>
      <el-card shadow="never" class="card-products">
        <div class="card-product">
          <div class="card-product-title">
            充值账户
          </div>
          <div class="card-product-value">
            <el-input v-model="rechargeMobile" placeholder="请输入充值手机号" clearable/>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-products">
        <div class="card-product">
          <div>
            可用里程
          </div>
          <div>
            {{ account?.balance_miles }}
          </div>
        </div>
        <div class="card-product">
          <div>
            支付里程
          </div>
          <div>
            {{ product?.mileTypes[copType.login]?.total }}
          </div>
        </div>
      </el-card>
      <div class="btn">
        <el-button type="danger" round
                   :disabled="Object.keys(account).length < 1 || account.balance_mile < parseInt(product?.mileTypes[copType.login]?.total)"
                   :loading="loading" @click="pay">立即兑换
        </el-button>
      </div>
    </div>
  </el-drawer>
  <send-sms-components :show="sendSms" :login-account="account" v-if="sendSms" @sends="pay"/>
  <real-name :dialog="realDialog" @changeModel="realDialog=false" v-if="realDialog"/>
</template>

<style scoped lang="less">
.product-detail {
  .product-title {
    display: flex;
    align-items: center;

    .product-logo {
      width: 100px;
      flex-basis: 100px;
      position: relative;
      margin-right: 10px;

      .product-type {
        position: absolute;
        top: 38px;
        left: 18px;

        .product-type-name {
          font-size: 1.35rem;
        }
      }
    }

    .product-values {
      line-height: 1.5;
      flex-basis: calc(100% - 110px);

      .el-text--danger {
        font-size: 1.75rem;
      }

      .el-text--warning {
        font-size: .65rem;
      }
    }
  }

  .card-products {
    margin: 15px auto;
    padding: 5px;

    .card-product {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;

      & + .card-product {
        border-top: var(--el-border);
      }

      .card-product-title {
        border-radius: 5px;
        padding: 5px;
        color: #D1AD11;
        border: 1px solid #D1AD11;
      }

      .card-product-value {
        flex-basis: 70%;

        .el-input {
          /deep/ .el-input__wrapper {
            box-shadow: none;
            border-radius: 0;
            border-bottom: var(--el-border);
          }
        }
      }
    }
  }

  .btn {
    width: 97%;
    margin: auto;

    .el-button {
      width: 100%;
      height: 50px;
      border-radius: 50px;
    }
  }
}
</style>
